module.exports = __webpack_public_path__ + "static/media/trade-2.1d4e763b.png";